import React from 'react';
import styled from 'styled-components';
import { media } from 'utils/style';
import { useTranslation } from 'react-i18next';

const LandingFooter = styled.footer`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 48px;
  pointer-events: none;
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: row;
  white-space:nowrap;
  z-index: 99;
  ${media.lessThan('small')`
    flex-direction: column;
  `};
`;

const LandingPolicy = styled.div`
  display: flex;
  width: 50%;
  height: 48px;
  padding: 14px 50px;
  background-color: #272A30;
  ${media.lessThan('small')`
    width: 100%;
  `};
  ${media.lessThan('extraSmall')`
    padding: 14px 24px;
  `};
`;

const LandingPolicyLink = styled.a`
    color: var(--grey500);
    text-decoration: none;
    margin-right: 14px;
    text-align: center;
    pointer-events: auto;
    &:hover {
      text-decoration: underline;
    }
`;

export const Footer = () => {
    const { t } = useTranslation('Landing');
    
    return (
      <LandingFooter>
          <LandingPolicy>
            <LandingPolicyLink
              href={`${t('links.web_url')}`}
              target="_blank">
              {t('links.web_title')}
            </LandingPolicyLink>
            <LandingPolicyLink
              href={`${t('links.policy_url')}`}
              target="_blank">
                {t('links.policy_title')}
              </LandingPolicyLink>
          </LandingPolicy>
        </LandingFooter>
    );
  };